import React, { useEffect, useState } from 'react';
import MaterialTable from 'material-table';
import Typography from '@material-ui/core/Typography';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import TableContainer from '@material-ui/core/TableContainer';
import Paper from '@material-ui/core/Paper';
import PriorityHighIcon from '@material-ui/icons/PriorityHigh';
import ClearIcon from '@material-ui/icons/Clear';
import BuildIcon from '@material-ui/icons/Build';
import DoneIcon from '@material-ui/icons/Done';
import { instanceAxios } from '../../InstanceAxios';
import environment from '../../environment';
import api from '../../environment';

function Anual(props) {
  const [idAtividade, setIdAtividade] = useState(props.match.params.id);
  const [atividade, setAtividade] = useState({});
  const [ano, setAno] = useState(props.match.params.ano);
  const [opcoes, setOpcoes] = useState({
    1: (
      <PriorityHighIcon
        style={{ color: '#FFFF00' }}
        title="Em Andamento"
        name="Em Andamento"
      />
    ),
    2: <ClearIcon style={{ color: '#FF0000' }} />,
    3: <BuildIcon style={{ color: '#ADFF2F' }} />,
    4: <DoneIcon style={{ color: '#008000' }} />,
  });
  const [columns, setColumns] = useState([
    { title: 'Nome', field: 'nome', editable: 'never' },
    {
      title: 'Nome Empresarial',
      field: 'UsuarioEmpresa.Empresa.razao_social',
      editable: 'never',
    },
    { title: 'CNPJ', field: 'UsuarioEmpresa.Empresa.cnpj', editable: 'never' },
    {
      title: 'Tipo tributação',
      field: 'UsuarioEmpresa.Empresa.TipoEmpresa.nome',
      editable: 'never',
    },
    {
      title: 'Cidade',
      field: 'UsuarioEmpresa.Empresa.cidade',
      editable: 'never',
    },
    {
      title: 'Estado',
      field: 'UsuarioEmpresa.Empresa.estado',
      editable: 'never',
    },
    {
      title: 'TlfMunicip',
      field: 'AtividadeAnual.tlfmunicip',
      lookup: opcoes,
    },
    {
      title: 'Defis',
      field: 'AtividadeAnual.defis',
      lookup: opcoes,
    },
    {
      title: 'Rais',
      field: 'AtividadeAnual.rais',
      lookup: opcoes,
    },
    {
      title: 'Reinf',
      field: 'AtividadeAnual.reinf',
      lookup: opcoes,
    },
    {
      title: 'Esocial',
      field: 'AtividadeAnual.esocial',
      lookup: opcoes,
    },
    {
      title: 'ECF',
      field: 'AtividadeAnual.ecf',
      lookup: opcoes,
    },
    {
      title: 'irpf',
      field: 'AtividadeAnual.irpf',
      lookup: opcoes,
    },
    {
      title: 'Dimob',
      field: 'AtividadeAnual.dimob',
      lookup: opcoes,
    },
    {
      title: 'Situação',
      field: 'AtividadeAnual.status_atividade',
      lookup: {
        1: 'Sem Movimentação',
        2: 'Realizado',
        3: 'Outra Praça',
      },
    },
    {
      title: 'Data entrega',
      field: 'AtividadeAnual.data_entrega',
      type: 'date',
    },
  ]);

  const handleAno = (event) => {
    window.location = `/atividadeAnual/${idAtividade}/${event.target.value}`;
  };

  useEffect(() => {
    const fetchAtividades = async () => {
      await instanceAxios(localStorage.getItem('toobiauth'))
        .get(`/atividades/${props.match.params.id}`)
        .then((res) => {
          setAtividade(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    };

    fetchAtividades();
  }, []);

  return (
    <>
      <Typography
        component="h3"
        variant="h3"
        align="left"
        color="textPrimary"
        gutterBottom
      >
        {atividade.nome}
      </Typography>
      <Typography variant="h5" align="left" color="textSecondary" component="p">
        {atividade.praca}
      </Typography>
      <Grid
        container
        spacing={1}
        justify="left"
        alignItems="left"
        style={{ paddingTop: '3%' }}
      >
        <Grid item xs={6} sm={3} md={3} lg={3}>
          <FormControl variant="outlined">
            <InputLabel>Ano</InputLabel>
            <Select value={ano} onChange={handleAno} label="Ano">
              <MenuItem value={2019}>2019</MenuItem>
              <MenuItem value={2020}>2020</MenuItem>
            </Select>
          </FormControl>
        </Grid>
      </Grid>
      <Grid
        container
        spacing={1}
        justify="left"
        alignItems="left"
        style={{ paddingTop: '3%' }}
      >
        <TableContainer component={Paper}>
          <MaterialTable
            localization={{
              pagination: {
                labelDisplayedRows: '{from}-{to} de {count}',
              },
              toolbar: {
                nRowsSelected: '{0} linhas(s) selecionadas',
              },
              header: {
                actions: 'Ações',
              },
              body: {
                emptyDataSourceMessage: 'Sem dados para mostrar',
                filterRow: {
                  filterTooltip: 'Filtro',
                },
              },
            }}
            title="Atividade Anual"
            columns={columns}
            data={(query) =>
              new Promise((resolve, reject) => {
                const url = `${api}/atividades/anual/${
                  props.match.params.id
                }?ano=${ano}&offset=${Number(query.page)}&search=${
                  query.search
                }`;
                fetch(url, {
                  method: 'get',
                  headers: {
                    authorization: `Bearer ${localStorage.getItem(
                      'toobiauth'
                    )}`,
                  },
                })
                  .then((response) => response.json())
                  .then((result) => {
                    resolve({
                      data: result.atividadeAnualUsuarios,
                      page: result.page,
                      totalCount: result.count,
                    });
                  });
              })
            }
            editable={{
              onRowUpdate: (newData, oldData) =>
                new Promise(async (resolve, reject) => {
                  await instanceAxios(localStorage.getItem('toobiauth'))
                    .post(
                      `${environment}/atividades/anual`,
                      newData.AtividadeAnual
                    )
                    .then((res) => {
                      if (res) {
                        window.location.reload();
                      }
                    })
                    .catch((err) => {
                      console.log(err);
                      alert('Erro ao atualizar dados');
                      resolve();
                    });
                }),
            }}
          />
        </TableContainer>
      </Grid>
    </>
  );
}

export default Anual;
